import {
  IgetLanguagesAPIResponse,
  IPingAPIResponse,
  TGetBannersResponse,
  IgetAssociationsStatesAPIResponse,
  IGetExchangesAPIResponse,
  IGetCountryDataAPIResponse,
  IGetPointsOfSaleCategoriesAPIResponse,
  ICreatePointOfSaleCategoryAPIRequestBody,
  ICreatePointOfSaleCategoryAPIResponse,
  IUpdatePointOfSaleCategoryAPIRequestBody,
  IUpdatePointOfSaleCategoryAPIResponse,
  IDeletePointOfSaleCategoryAPIResponse,
} from 'api/endpoints/general/general.response.interface';
import { getBasePath } from '../../utils/config';

export const pingAPI = async ({
  token,
}: {
  token: string;
}): Promise<IPingAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${getBasePath()}/status/ping`, params);
  const data = await response.json();
  return { response, data };
};

export const getLanguagesAPI = async ({
  token,
}: {
  token: string;
}): Promise<IgetLanguagesAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${getBasePath()}/user/get_languages`, params);
  const data = await response.json();
  return { response, data };
};

export const getBannersAPI = async ({
  token,
}: {
  token: string;
}): Promise<TGetBannersResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${getBasePath()}/multimedia/get_banners`, params);
  const data = await response.json();
  return { response, data };
};

export const getAssociationsStatesAPI = async ({
  token,
}: {
  token: string;
}): Promise<IgetAssociationsStatesAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/client_profile/get_association_states`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const getExchangesAPI = async ({
  token,
}: {
  token: string;
}): Promise<IGetExchangesAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/point_of_sale_profile/get_exchange_list`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const getCountriesAPI = async ({
  token,
}: {
  token: string;
}): Promise<IGetCountryDataAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${getBasePath()}/country/get_all`, params);
  const data = await response.json();
  return { response, data };
};

// Points of Sale Categories API ////////////////////////////////////////////////
export const getPointsOfSaleCategoriesAPI = async ({
  token,
}: {
  token: string;
}): Promise<IGetPointsOfSaleCategoriesAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/point_of_sale_profile/get_point_of_sale_category`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const createPointOfSaleCategoryAPI = async ({
  body,
  token,
}: {
  body: ICreatePointOfSaleCategoryAPIRequestBody;
  token: string;
}): Promise<ICreatePointOfSaleCategoryAPIResponse> => {
  const params = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/point_of_sale_profile/create_category`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const updatePointOfSaleCategoryAPI = async ({
  body,
  token,
}: {
  body: IUpdatePointOfSaleCategoryAPIRequestBody;
  token: string;
}): Promise<IUpdatePointOfSaleCategoryAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/point_of_sale_profile/update_category`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const deletePointOfSaleCategoryAPI = async ({
  categoryId,
  token,
}: {
  categoryId: string;
  token: string;
}): Promise<IDeletePointOfSaleCategoryAPIResponse> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/point_of_sale_profile/delete_category?id=${categoryId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};
/////////////////////////////////////////////////////////////////////////////////
